
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/welcome-packet",
      function () {
        return require("private-next-pages/welcome-packet.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/welcome-packet"])
      });
    }
  